import React from 'react';
import { IconButton } from '@paypalcorp/pp-react';
import templateData from '../utility/getTemplateData';

export default function BackButton() {
  const navigateBack = () => {
    window.location.href = templateData.hideLandingPage
      ? templateData.charityCancelUrl
      : '/donate?token=' + templateData.token;
  };

  return (
    <IconButton
      data-testid="back-button"
      iconName="arrow-left"
      onClick={navigateBack}
      className="back-button"
    />
  );
}
